import jsPDF from "jspdf";
import "jspdf-autotable";
import deepFind from "./deepFind";

// eslint-disable-next-line import/no-anonymous-default-export
export default (
  title,
  headers,
  data,
  orientation = "landscape",
  size = "A4"
) => {
  if (!data) return;
  
  const unit = "pt";
  //   const size = "A4"; // Use A1, A2, A3 or A4
  //   const orientation = "portrait"; // portrait or landscape

  const marginLeft = 40;
  const doc = new jsPDF(orientation, unit, size);

  doc.setFontSize(15);

  const filteredHeaders = headers.filter(
    (elt) => elt && elt.title && elt.key !== "action" && elt.key !== "multiple-actions"
  );
  let _headers = filteredHeaders.map((elt) => elt.title);
  let keys = filteredHeaders.map((elt) => elt.key);

  const body = data.map((elt) =>
    keys.map((key) => {
      const val = elt[key] !== undefined ? elt[key] : deepFind(elt, key);
      if (Array.isArray(val)) return val.map((v) => v?.name || v).join(", ");
      return val ?? "";
    })
  );

  let content = {
    startY: 50,
    head: [_headers],
    body,
    styles: { halign: "left" },
    headStyles: { fillColor: [11, 147, 71] },
    alternateRowStyles: { fillColor: [236, 247, 241] },
    tableLineColor: [11, 147, 71],
    tableLineWidth: 0.1,
  };

  doc.text(title, marginLeft, 40);
  doc.autoTable(content);
  doc.save(
    title.toUpperCase() +
      "-" +
      new Date().getMonth() +
      "-" +
      new Date().getFullYear() +
      ".pdf"
  );
};
